"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var OrderTableTr = /** @class */ (function (_super) {
    __extends(OrderTableTr, _super);
    function OrderTableTr(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    OrderTableTr.prototype.handleClick = function () {
        this.setState(function (prevState) { return ({
            isOpen: !prevState.isOpen
        }); });
    };
    OrderTableTr.prototype.render = function () {
        var styles = "flex flex-col pb-0-4 justify-start items-center";
        var innerItemStyles = "w-full text-base";
        var _a = this.props, order = _a.order, preview = _a.preview, width = _a.width;
        var isOpen = this.state.isOpen;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "block flex pb-0-4 text-base text-grey-dark" },
                React.createElement("div", { className: "" + styles, style: { width: "" + width[0].width } },
                    React.createElement("a", { href: order.customer_url, title: order.name, className: innerItemStyles }, order.name)),
                React.createElement("div", { className: "" + styles, style: { width: "" + width[1].width } },
                    React.createElement("div", { className: innerItemStyles }, next_components_1.ShopifyNext.Utils.formatDate(order.created_at, "DD/MM/YYYY"))),
                React.createElement("div", { className: "" + styles, style: { width: "" + width[2].width } },
                    React.createElement("div", { className: innerItemStyles }, order.financial_status_label)),
                React.createElement("div", { className: "" + styles, style: { width: "" + width[3].width } },
                    React.createElement("div", { className: innerItemStyles }, order.fulfillment_status_label)),
                React.createElement("div", { className: "" + styles, style: { width: "" + width[4].width } },
                    React.createElement("div", { className: innerItemStyles }, next_components_1.ShopifyNext.Utils.formatMoney(order.total_price))),
                preview && (React.createElement("div", { className: styles + " flex", style: { width: "" + width[5].width } },
                    React.createElement("button", { onClick: this.handleClick },
                        React.createElement(Snippets.Svg, { height: 12, name: "" + (isOpen ? "minus" : "plus"), className: "items-center" }))))),
            React.createElement("div", { className: (isOpen ? "" : "hidden") + " w-full" },
                React.createElement(Snippets.Order, { order: order, onClick: this.handleClick }))));
    };
    OrderTableTr.defaultProps = {
        preview: false
    };
    return OrderTableTr;
}(React.PureComponent));
exports.OrderTableTr = OrderTableTr;
